// How tall the frame is held open while an answer-variants chart is still being fetched, ported
// from the coffee block base (getChartPlaceholderHeight).
//
// A chart drawn in columns is always the same height, whatever it is counting. One drawn in bars
// grows with the answers instead: past the seven the base height already fits, every further bar
// adds a row of its own.

import { getDefaultChartMode } from '@aytm/app/stats/page/question-views/answer-variants/components/chart/lib/chartModes'
import { CHART_PLACEHOLDER_HEIGHT } from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'

const BAR_ROW_HEIGHT = 40

// how many bars the base height already has room for
const BAR_ROWS_INCLUDED = 7

const COLUMN_CHART_MODES = ['pie', 'respondents', 'percents', 'area', 'scatter']

const BAR_CHART_MODES = ['brespondents', 'bpercents']

// The height the chart the question is about to draw will need. A mode that draws no chart at all
// -- a map, a word cloud -- has no frame to hold open, and says so.
export const calcChartPlaceholderHeight = ({
  chartMode,
  globalChartMode,
  answer,
  percentsOnly = false,
  isRType = false,
  itemCount = 0
} = {}) => {
  const mode = getDefaultChartMode({ chartMode, globalChartMode, answer, percentsOnly, isRType })

  if (COLUMN_CHART_MODES.includes(mode)) return CHART_PLACEHOLDER_HEIGHT

  if (BAR_CHART_MODES.includes(mode)) {
    return CHART_PLACEHOLDER_HEIGHT + BAR_ROW_HEIGHT * (itemCount - BAR_ROWS_INCLUDED)
  }

  return null
}
